import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  position: relative;
  width: 100px;
  margin-top':
`;

export const Input = styled.input<{ $borderColor?: string; $focusColor?: string }>`
  height: 32px;
  width: 110%;
  border-radius: 0.5rem;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  padding: 0 1rem;
  font-size: 0.875rem;
  outline: none;
  text-align: center;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  &:focus {
    border-color: ${({ $focusColor }) => $focusColor};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
  @media (max-width: 1440px) {
    width: 117%;
  }
`;

export const IncrementButton = styled.button<{ $backgroundColor?: string, $color?: string}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: -10px;
  width: 32px;
  height: 32px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $color }) => $color};
  border-radius: 50%;
  font-size: 1.25rem;
  cursor: pointer;
  @media (max-width: 1440px) {
    width: 28px;
    height: 28px;
    right: -14px;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DecrementButton = styled.button<{ $backgroundColor?: string, $color?: string  }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: -0;
  width: 32px;
  height: 32px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ color }) => color};
  border-radius: 50%;
  font-size: 1.25rem;
  cursor: pointer;
  @media (max-width: 1440px) {
    width: 28px;
    height: 28px;  
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  font-size: 0.75rem;
  color: #ef4444;
`;
